<template>
  <div class="ttf-cont" ref="ttf_container" :style="{ width: cont_elem_width }">
    <v-select
      class="ttf-v-selector"
      @input="check_and_set_tz($event)"
      :label="label_field"
      :options="options"
      :value="form_selected"
      :clearable="false"
      :appendToBody="true"
      :calculate-position="with_popper"
      :reduce="option => option[value_field]"
      :disabled="disabled"
      :filter-by="filterBy"
      ref="ttf_select"
      @open="update_cont_width"
      @close="update_cont_width"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
        ><slot :name="slot" v-bind="scope"/></template
    ></v-select>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import { createPopper } from "@popperjs/core";

export default {
  name: "TypeToSelect",
  components: {
    vSelect
  },
  model: {
    prop: "form_selected",
    event: "changed-form-selected"
  },
  props: {
    form_selected: {},
    label_field: {
      type: String,
      default: "label"
    },
    value_field: {
      type: String,
      default: "id"
    },
    options: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterBy: {
      default: undefined
    }
  },
  data() {
    return {
      cont_elem_width: "auto",
      last_cont_elem_width: ""
    };
  },
  methods: {
    check_and_set_tz(selected_value) {
      this.$emit("changed-form-selected", selected_value);
      return;
    },
    with_popper(dropdownList, component, { width }) {
      //code taken from https://vue-select.org/guide/positioning.html#popper-js-integration
      /**
       * We need to explicitly define the dropdown width since
       * it is usually inherited from the parent with CSS.
       */
      dropdownList.style.width = width;
      dropdownList.style["z-index"] = 99000;
      dropdownList.classList.add("wpcal-v-select-body-dropdown"); //append to body class

      /**
       * Here we position the dropdownList relative to the $refs.toggle Element.
       *
       * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
       * the dropdownList overlap by 1 pixel.
       *
       * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
       * wrapper so that we can set some styles for when the dropdown is placed
       * above.
       */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        //placement: this.placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1]
            }
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            }
          },
          {
            name: "preventOverflow",
            options: {
              boundary: this.$refs.ttf_container,
              padding: -1
            }
          }
        ]
      });

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy();
    },
    update_cont_width() {
      if (this.$refs.ttf_select.$data.open) {
        this.cont_elem_width = this.last_cont_elem_width
          ? this.last_cont_elem_width + "px"
          : "auto";
      } else {
        this.cont_elem_width = "auto";
        this.$nextTick(() => {
          this.last_cont_elem_width = this.$refs["ttf_container"].clientWidth;
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.last_cont_elem_width = this.$refs["ttf_container"].clientWidth;
    });
  },
  watch: {
    options() {
      this.$nextTick(() => {
        this.last_cont_elem_width = this.$refs["ttf_container"].clientWidth;
      });
    }
  }
};
</script>
<style>
.ttf-cont {
  width: auto;
}
.ttf-cont.white .ttf-v-selector.vs--disabled {
  cursor: not-allowed;
}
.ttf-cont.white .ttf-v-selector .vs__dropdown-toggle {
  background-color: #fff;
}
.ttf-cont.no-border .ttf-v-selector .vs__dropdown-toggle {
  border: 0;
}
.ttf-v-selector .vs__dropdown-toggle {
  padding-bottom: 0;
  cursor: pointer;
  line-height: 1.2em;
  border: 1px solid #b1b6d1;
}
#wpcal-widget .widget-main .vs__dropdown-toggle {
  border: 1px solid #e9ecf2;
}
#wpcal-widget .widget-main .ttf-cont {
  margin: 10px 10px 20px 10px;
  width: auto;
}
.ttf-v-selector .vs__dropdown-toggle .vs__actions {
  display: none;
}
.ttf-v-selector .vs__dropdown-toggle + .vs__dropdown-menu li {
  margin: 0;
  padding: 7px;
  font-size: 13px;
}
.vs__dropdown-option--highlight {
  background: #567bf3;
  color: #fff !important;
}

.ttf-v-selector::after {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4.5 7.5'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:none;stroke:%23131336;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Eicon-back%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpolyline class='cls-1' points='3.75 0.75 0.75 3.75 3.75 6.75'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  position: absolute;
  width: 6px;
  height: 10px;
  -webkit-transform: rotate(-90deg);
  transform: rotate(-90deg);
  top: 11px;
  right: 10px;
}
.ttf-cont .vs--single .vs__selected {
  margin: 4px 4px 5px 0;
  padding: 0;
  padding-left: 0;
  font-size: 13px;
  white-space: nowrap;
  min-width: 40px;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ttf-cont .vs--single.vs--open .vs__selected {
  margin: 6px 0 8px 0;
}
#wpcal-widget .widget-main .vs--single .vs__selected {
  margin: 5px 0;
  color: #131336;
}
.v-select {
  background-color: transparent;
  cursor: pointer;
}
.v-select .vs__search,
.v-select .vs__search:focus {
  border: 0 !important;
  background-color: transparent !important;
  z-index: 1;
}
.v-select .vs__search {
  cursor: pointer;
  font-size: 13px;
  padding: 0 8px;
  height: 30px;
  width: 10px;
  margin-top: 0;
  margin-bottom: 0;
  color: #131336 !important;
}
.vs--disabled .vs__selected {
  cursor: pointer;
}
.ttf-cont .v-select.vs--open .vs__search {
  padding: 0;
  margin-top: 0;
  padding-right: 20px;
  cursor: text;
}
.vs--single.vs--open .vs__selected {
  margin: 7px 0;
}
.v-select.vs--disabled {
  opacity: 0.7;
}
.wpcal-v-select-body-dropdown li {
  margin: 0;
  font-family: "Rubik";
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
}
ul.filters-bar li.bf-when .vs__selected-options {
  padding-left: 47px;
}
ul.filters-bar li.bf-status .vs__selected-options {
  padding-left: 50px;
}
ul.filters-bar li.bf-host .vs__selected-options {
  padding-left: 40px;
}
ul.filters-bar li.bf-et .vs__selected-options {
  padding-left: 75px;
}
.ttf-cont .v-select .vs__search {
}
</style>
